module.exports = __webpack_public_path__ + "static/media/hexagan-pending.ae1ef146.svg";